// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const fixtureRosterExportFields = [
  {
    titleIntlKey: "fixtureRoster.columns.entity.title",
    fields: ["entityId", "entityExternalId", "entityName"],
  },
  {
    titleIntlKey: "fixtureRoster.columns.person.title",
    fields: ["personId", "personExternalId", "personName"],
  },
  {
    titleIntlKey: "fixtureRoster.columns.fixtureRoster.title",
    fields: ["externalId", "bib", "position", "starter"],
  },
];

export const defaultFixtureRosterExportFieldNames = ["entityName", "personId", "personName", "bib", "position", "starter"];
